export const EXPRESSION_SCHEMAS = [
    "expressionSchema",
    "codedDataFieldContinuingResources",
    "codedDataFieldSoundRecordingsAndMusic",
]

export interface Expression {
    id: string
    type: string
    entityType?: string
}